// extracted by mini-css-extract-plugin
export default {"tabWrapper":"Tab_tabWrapper__bLzys","tabName":"Tab_tabName__vSqf4","selected":"Tab_selected__C9xwh"};